import Vue from 'vue';
import Vuex from 'vuex';

import { alert } from './alert.module';
import { account } from './account.module';
import { title } from './title.module'
import { featuresModule } from './features.module'
import {visits} from './visits.module'
import {companySettingsModule} from './company_settings.module'
import { abilityPlugin, ability as appAbility, buildPermissionRules } from './ability'
import { therapistListModule } from './therapist_list.module'
export const ability = appAbility
Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        alert,
        account,
        title,
        visits,
        featuresModule,
        companySettingsModule,
        therapistListModule
    },
    actions: {
        updateAbilityPermissions({commit, state}) {
            if(state.account.permissions != null){
                appAbility.update(buildPermissionRules(state.account.permissions))           
            }
        }
    },
    plugins: [abilityPlugin]
});
